import { EventEmitter, HostListener } from '@angular/core';
import { Directive, ElementRef, Output } from '@angular/core';

@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective {

  constructor(
    private _elementRef : ElementRef
  ) { }

  @Output()
  appClickOutside = new EventEmitter();

  @HostListener('document:click',['$event.target'])
  onClick(targetElement){
    const clickInside = this._elementRef.nativeElement.contains(targetElement)
    if(!clickInside && targetElement.id === "overlay"){
      this.appClickOutside.emit("outside click");
    }
  }

}
